import React, {useCallback, useState, useEffect} from 'react';
import styled from "@emotion/styled";

import { COLORS } from '../../utils/consts';

import Toggle from '../Shared/Toggle';
import { MapType, MarkerType } from '../../types/dataTypes';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { mapGetLayerExists } from '../../utils/mapDataHandler';
import TooltipWrapper from '../Shared/TooltipWrapper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


type ViewLayerProps = {
  toggleInit?: boolean,
  active?: boolean,
  isMarker?: boolean,
  layerId: string,
  layerIdArray: string[],
  map: MapType,
  markerClass?: string,
  layerName: string,
  toolTipText?: string,
  setSelectedLayers: Function
}

function ViewLayerVector({toggleInit=true, layerId, layerName, layerIdArray, map, isMarker=false, markerClass, toolTipText, setSelectedLayers }: ViewLayerProps) {
  const mapCurrent = map.current;
  const [toggle, setToggle] = useState(toggleInit);

  const toggleLayer = useCallback(() => {
    if (!mapCurrent) return; // wait for map to initialize
    setToggle(!toggle);
    if (isMarker && markerClass){
      const markers = Array.from(document.getElementsByClassName(markerClass) as HTMLCollectionOf<HTMLElement>)
      if(toggle){
        markers.forEach(el => {
          el.style.visibility = 'hidden' 
        })
      } else {
        markers.forEach(el => {
          el.style.visibility = 'visible' 
        })
      }
    } else {
      if(mapGetLayerExists(mapCurrent, layerId)){
        layerIdArray.forEach(layerId => {toggle?mapCurrent.setLayoutProperty(layerId,'visibility','none')
          : mapCurrent.setLayoutProperty(layerId,'visibility','visible');
        })
      }
    }
    setSelectedLayers((prev: any) => prev.map((layer: any) => layer.layerId === layerId ? {...layer, isSelected: !layer.isSelected} : layer))
  }, [mapCurrent, toggle, isMarker, markerClass, layerIdArray]);

  return (
    <ContainerFormStyle name='Show Layer Form' >
      <ContainerLabelStyle htmlFor={layerId} toggle={toggle}>
      <Toggle
              layerId={layerId}
              toggle={toggle}
              toggleLayer={toggleLayer}    
          />
          {layerName}
          {/* {showAttribution&&<div className={styles.attribution}>{attribution}</div>} */}
          {toolTipText && <TooltipWrapper content={toolTipText} positionFromDivBottom="35px" margin="0 0 0 5px">
            <FontAwesomeIcon icon="info-circle" /> 
          </TooltipWrapper>}
      </ContainerLabelStyle>
    </ContainerFormStyle>
  )
}

export default ViewLayerVector;

const ContainerFormStyle = styled.form<{}>(()=>`
    margin: 8px 0;
`)

const ContainerLabelStyle = styled.label<{toggle?: boolean}>(({toggle=true})=>`
    display: flex;
    justify-content: flex-start;
    width: 100%;
    position: relative;
    ${!toggle && `color: ${COLORS.FONT.INACTIVE};`}
`)
